/* eslint-disable better-mutation/no-mutation */

import { isServer } from 'tradera/utils/nextjs';

if (isServer) {
    // Do not remove this without also removing the disable of eslint better-mutation/no-mutation at top of file.
    throw new Error(
        'This implementation may not compatible with SSR where global properties are shared between server instances'
    );
}

let acceptsMarketing = true;

export function setAcceptsMarketing(accepts = true) {
    acceptsMarketing = accepts;
}

export function getAcceptsMarketing() {
    return !!acceptsMarketing;
}

export function triggerUserSignedUpEvent(memberId, memberEmail) {
    const data = {
        event: 'blueshiftSignupEvent',
        memberId,
        memberEmail,
        memberMarketingSubscribed: acceptsMarketing
    };
    window.dataLayer.push(data);
}
